import React, { useEffect, useState } from 'react';
import axios from "axios";
import { toast } from "react-toastify";

const SubmitionResult = () => {
    const [submitionResult, setSubmitionResult] = useState(null);
    const [event, setEvent] = useState(null);
    const [phoneNo, setPhoneNo] = useState('');
    const [allSubmitions, setAllSubmitions] = useState([]);

    useEffect(() => {
        document.title = 'زانکوبادینان | فورما تومارکرنێ';
        fetchAllSubmitions();
    }, []);

    useEffect(() => {
        if (submitionResult && allSubmitions.length > 0) {
            calculateEvent();
        }
    }, [submitionResult, allSubmitions]);

    const fetchAllSubmitions = async () => {
        try {
            const res = await axios.get('/api/submition-count');
            setAllSubmitions(res.data);
        } catch (error) {
            console.error("Error fetching all submissions:", error);
            toast.error("Error fetching data. Please try again.");
        }
    };

    const fetchSubmitionResult = async () => {
        try {
            const res = await axios.get(`/api/submition-result/${phoneNo}`);
            if (res.data && res.data.length > 0) {
                setSubmitionResult(res.data[0]);
            } else {
                toast.error("No submission found for this phone number.");
                setSubmitionResult(null);
            }
        } catch (error) {
            console.error("Error fetching submission result:", error);
            toast.error("Error fetching data. Please try again.");
        }
    };

    const calculateEvent = () => {
        const totalCount = allSubmitions.length;
        const submissionIndex = allSubmitions.findIndex(s => s.id === submitionResult.id);

        if (submissionIndex === -1) {
            console.warn("Submission not found in the list");
            setEvent(null);
            return;
        }

        // Day configuration: First day = 100, other days = 350 each
        const firstDayLimit = 100;
        const otherDaysLimit = 350;

        const events = [
            'روژا ئێکێ',    // Day 1 - 100 submissions
            'روژا دووێ',    // Day 2 - 350 submissions  
            'روژا سیێ',     // Day 3 - 350 submissions
            'روژا چارێ',    // Day 4 - 350 submissions
            'روژا پێنجێ',   // Day 5 - 350 submissions
            'روژا شەشێ',   // Day 6 - 350 submissions
            'روژا حەفتێ',   // Day 7 - 350 submissions
            'روژا هەشتێ'    // Day 8 - 350 submissions
        ];

        // Calculate cumulative limits for each day
        const cumulativeLimits = [];
        cumulativeLimits[0] = firstDayLimit; // Day 1: 0-99

        for (let i = 1; i < events.length; i++) {
            cumulativeLimits[i] = cumulativeLimits[i - 1] + otherDaysLimit;
        }

        // Find which day this submission belongs to
        let foundEvent = null;
        for (let i = 0; i < cumulativeLimits.length; i++) {
            if (submissionIndex < cumulativeLimits[i]) {
                foundEvent = events[i];
                break;
            }
        }

        // If submission index exceeds all defined days, assign to last day
        if (!foundEvent) {
            foundEvent = events[events.length - 1];
        }

        setEvent(foundEvent);
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        if (!phoneNo.trim()) {
            toast.error("Please enter a phone number.");
            return;
        }
        fetchSubmitionResult();
    };

    // Helper function to get day information for display (optional)
    const getDayInfo = () => {
        if (!allSubmitions.length) return null;

        const firstDayLimit = 100;
        const otherDaysLimit = 350;
        const totalCount = allSubmitions.length;

        const dayInfo = [];
        let currentLimit = 0;

        // Day 1
        currentLimit += firstDayLimit;
        dayInfo.push({
            day: 'روژا ئێکێ',
            limit: firstDayLimit,
            cumulativeLimit: currentLimit,
            range: `0 - ${Math.min(firstDayLimit - 1, totalCount - 1)}`
        });

        // Other days
        for (let i = 2; i <= 8; i++) {
            const prevLimit = currentLimit;
            currentLimit += otherDaysLimit;

            if (prevLimit < totalCount) {
                dayInfo.push({
                    day: i === 2 ? 'روژا دووێ' : i === 3 ? 'روژا سیێ' : i === 4 ? 'روژا چارێ' :
                        i === 5 ? 'روژا پێنجێ' : i === 6 ? 'روژا شەشێ' : i === 7 ? 'روژا حەفتێ' : 'روژا هەشتێ',
                    limit: otherDaysLimit,
                    cumulativeLimit: currentLimit,
                    range: `${prevLimit} - ${Math.min(currentLimit - 1, totalCount - 1)}`
                });
            }
        }

        return dayInfo;
    };

    return (
        <main>
            <section className="event__area pt-150 pb-120 p-relative">
                <div className="container">
                    <div className="row">
                        <div className="col-xxl-7 col-xl-7 col-lg-7">
                            <div className="course__wrapper">
                                <div className="page__title-content mb-25">
                                    <h2 className="section__title">  پێزانین دەربارەی<span className="yellow-bg">  فۆرم داگرتن<img src="../../assets/img/yellow-bg.png" alt="sam" /></span></h2>
                                </div>
                                <div className="course__tab-content mb-95">
                                    <img src="../../uploads/resultsub.jpeg" alt="shape" className="shape shape-1" />
                                    <p>
                                        ناڤ و نیشانێ سەنتەرێ زانکۆلاین ب سەر پەرشتی مامۆستا سیروان بۆ داگرتنا فۆرما زانکۆلاین و پارالێل و ئێڤاران ل بەرامبەر دەرکێ زانکۆیا دهۆک.
                                        بۆ هەڤالێن خۆ پۆلا12فرێکەن.
                                    </p>
   

                                    {submitionResult && (
                                        <div className="form-group mb-5 mt-40">
                                            <div className="alert alert-info">
                                                <p><strong>ناڤێ سیانی:</strong> {submitionResult.full_name}</p>
                                                <p><strong>ژ.مۆبایل:</strong> {submitionResult.phone_no}</p>
                                                <p><strong>پشک:</strong> {submitionResult.department}</p>
                                                <p><strong>ژڤانا داگرتنا فورمی:</strong> {event}</p>
                                                <small className='text-muted'>
                                                    <strong>تێبینی:</strong> هەر دەمێ زانکۆلاین ڤەبوو، ل دویف ڕۆژا بۆ تە هاتییە دەستنیشان کرن سەرەدانا مە بکە
                                                </small>
                                            </div>
                                        </div>
                                    )}
                                </div>

                                <div className="course__tab-content mb-95">
                                    <form onSubmit={handleSubmit}>
                                        <div className="form-group mb-5">
                                            <label htmlFor="phone_no" className='mb-1'>
                                                <strong>ژ.مۆبایل</strong>
                                            </label>
                                            <input
                                                type="tel"
                                                className="form-control"
                                                name="phone_no"
                                                placeholder='ژ.مۆبایل بنڤیسن'
                                                required
                                                value={phoneNo}
                                                onChange={(e) => setPhoneNo(e.target.value)}
                                            />
                                        </div>
                                        <div className="form-group mb-5 mt-40">
                                            <button type="submit" className="e-btn e-btn-7 w-100">
                                                جێبەجێکرن <i className="far fa-check"></i>
                                            </button>
                                        </div>
                                    </form>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </main>
    );
}

export default SubmitionResult;